var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "LOGO_-_YOUTUBE",
    "data-name": "LOGO - YOUTUBE",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.063,
    height: 12.795,
    viewBox: "0 0 18.063 12.795",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Black"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Youtube",
    d: "M207.167,376.757v-5.111l4.88,2.564Zm10.716-6a3.955,3.955,0,0,0-.718-1.806,2.57,2.57,0,0,0-1.81-.77c-2.528-.184-6.319-.184-6.319-.184h-.008s-3.792,0-6.319.184a2.571,2.571,0,0,0-1.81.77,3.952,3.952,0,0,0-.717,1.806A27.721,27.721,0,0,0,200,373.7v1.38a27.709,27.709,0,0,0,.181,2.944,3.952,3.952,0,0,0,.717,1.805,3.049,3.049,0,0,0,1.992.778c1.445.14,6.141.183,6.141.183s3.8-.006,6.323-.19a2.574,2.574,0,0,0,1.81-.771,3.955,3.955,0,0,0,.718-1.805,27.693,27.693,0,0,0,.181-2.944V373.7a27.705,27.705,0,0,0-.181-2.944Z",
    transform: "translate(-200 -368)",
    fill: "#3c3c3b",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.779242cfc28ec6f9b5208a105f74bcf3.svg";
export { ForwardRef as ReactComponent };